<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage shipping department</small>
      </legend>
      <div></div>
      <div class="shippingsLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: blue"></i>loading shippings...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemShippings"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'Action'">
            <button class="btn btn-info btn-sm btn-rounded" @click="viewShipping(props.row.id)">
              <i class="fa fa-edit" data-toggle="tooltip" title="Edit shipping details!"></i> Edit Shipping details
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by file code"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by customer name"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by bol"
          }
        },
        {
          label: "Shipping line",
          field: "shipping_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by shippingline"
          }
        },
        {
          label: "Shipping line charges",
          field: "shippingline_charges",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" ,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by shipping line charges  date"
          }// outputs Mar 16th 2018
        },
        {
          label: "Do status",
          field: "do_status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by do status"
          }
        },
        {
          label: "Do received date",
          field: "do_received_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" ,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by do received date"
          }// outputs Mar 16th 2018
        },
        {
          label: "Do remark",
          field: "do_remark",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by do remark"
          }
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadShipping();
  },
  computed: {
    ...mapGetters(["systemShippings"])
  },
  methods: {
    ...mapActions(["loadShipping", "viewShipping"])
  }
};
</script>


// WEBPACK FOOTER //
// src/shippingdepartment/manageshippingdepartments.vue